import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {BrandLogoModel} from "../models/view/brandLogoModel";

export const useBrandQuery = () => {
    const {model: {brand}} = useProductDetailsQuery();
    return {model: new BrandLogoModel(brand)};
}